import { formatInLao } from "@/shared/lib/date-time";

/** Format expire date for Lao WhatsApp messages (dd/MM/yyyy). */
export function formatExpireDateLo(
  expireDate: string | Date | null | undefined,
): string {
  if (!expireDate) return "–";
  const formatted = formatInLao(expireDate, "dd/MM/yyyy");
  return formatted === "–" ? String(expireDate) : formatted;
}
